function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.6053 5.25074H18.1053V5.75074V8.79525V9.29525H18.6053H44.6528H45.1528V8.79525V5.75074V5.25074H44.6528H18.6053ZM5.07418 13.0312H4.57418V13.5312V97.4243V97.9243H5.07418H58.184H58.684V97.4243V13.5312V13.0312H58.184H5.07418ZM8.79525 0.5H54.4629C59.2485 0.5 62.7582 4.32284 62.7582 8.79525V105.205C62.7582 109.677 59.2485 113.5 54.4629 113.5H8.79525C4.33549 113.5 0.5 109.665 0.5 105.205V8.79525C0.5 4.33549 4.33549 0.5 8.79525 0.5ZM36.3576 105.205C36.3576 102.614 34.4932 100.307 31.7982 100.307C29.1541 100.307 26.9006 102.561 26.9006 105.205C26.9006 107.849 29.1541 110.102 31.7982 110.102C34.4932 110.102 36.3576 107.795 36.3576 105.205Z",
  fill: "#F5F5F5",
  stroke: "#9C9C9C"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 5.07422,
  y: 13.5312,
  width: 53.1098,
  height: 83.8932,
  fill: "#FFE3D4"
});

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 114,
    viewBox: "0 0 64 114",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone.d75bd12b.svg";
export { ForwardRef as ReactComponent };